import { Mail, MapPin, Clock } from "lucide-react";
import Reveal from "../Reveal";
import { useT } from "../../i18n/I18nProvider";

export const ContactInfo = () => {
  const t = useT();

  return (
    <Reveal delay={140} className="lg:col-span-5 space-y-4 md:space-y-5">
      <div className="card-flat p-6 md:p-10">
        <div className="overline mb-3 md:mb-4">
          {t("contact.info.emailTitle")}
        </div>
        <a
          href="mailto:info@mysteriousstew.com"
          className="font-display text-2xl sm:text-3xl md:text-4xl tracking-tightest underline-grow inline-flex items-start gap-3 break-all"
          data-testid="contact-direct-email"
        >
          info@mysteriousstew.com
          <Mail
            className="w-5 h-5 mt-2 md:mt-3 text-ink-500 shrink-0"
            strokeWidth={1.4}
          />
        </a>
        <p className="mt-4 md:mt-5 text-[13px] text-ink-500 leading-relaxed">
          {t("contact.info.emailNote")}
        </p>
      </div>

      <div className="card-flat p-6 md:p-10">
        <div className="overline mb-3 md:mb-4">
          {t("contact.info.whereTitle")}
        </div>
        <div className="flex items-start gap-3">
          <MapPin
            className="w-5 h-5 mt-1 text-ink-500 shrink-0"
            strokeWidth={1.4}
          />
          <div>
            <div className="font-display text-xl md:text-2xl tracking-tight">
              {t("contact.info.whereValue")}
            </div>
            <p className="text-[13px] text-ink-500 mt-1">
              {t("contact.info.whereNote")}
            </p>
          </div>
        </div>
      </div>

      <div className="card-flat p-6 md:p-10">
        <div className="overline mb-3 md:mb-4">
          {t("contact.info.timeTitle")}
        </div>
        <div className="flex items-start gap-3">
          <Clock
            className="w-5 h-5 mt-1 text-ink-500 shrink-0"
            strokeWidth={1.4}
          />
          <div>
            <div className="font-display text-xl md:text-2xl tracking-tight">
              {t("contact.info.timeValue")}
            </div>
            <p className="text-[13px] text-ink-500 mt-1">
              {t("contact.info.timeNote")}
            </p>
          </div>
        </div>
      </div>
    </Reveal>
  );
};
